// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MayorLink_wrapper__CmAhF","text-container":"MayorLink_text-container__3NdjJ","text":"MayorLink_text__3QUwx","icon":"MayorLink_icon__3FHck"};